import React from 'react';
import type { ReactElement } from 'react';
import { FilterPillButton } from './FilterPillButton';
import { FloorAreaFilter } from './FloorAreaFilter';
import { FilterPillButtonSheet } from './FilterPillButtonSheet';
import useMedia from '../../../../shared/useMedia';

const getPillLabel = (floorAreaRange: number[]): string | undefined => {
  const [minFloorArea, maxFloorArea] = floorAreaRange;
  const hasMinFloorArea = minFloorArea > 0;
  const hasMaxFloorArea = maxFloorArea > 0;

  if (!hasMinFloorArea && !hasMaxFloorArea) {
    return undefined;
  }

  if (!hasMinFloorArea) {
    return `Up to ${maxFloorArea}m²`;
  }

  if (!hasMaxFloorArea) {
    return `${minFloorArea}m²+`;
  }

  return `${minFloorArea}m²-${maxFloorArea}m²`;
};
export interface FilterPillFloorAreaProps {
  selectedFloorAreaRange: number[];
  initialFloorAreaRange: number[];
  onChange: (newPriceRange: number[]) => void;
  onReset?: () => void;
  onFilterPillClose: () => void;
  handleSearchOnClick: (onClose?: () => void) => void;
  trackPillClick: () => void;
}

export const FilterPillFloorArea = ({
  selectedFloorAreaRange,
  initialFloorAreaRange,
  onChange,
  onReset,
  onFilterPillClose,
  handleSearchOnClick,
  trackPillClick,
}: FilterPillFloorAreaProps): ReactElement => {
  const maybePillLabel = getPillLabel(initialFloorAreaRange);
  const { isMediumScreen, isLargeScreen } = useMedia();

  return !isMediumScreen && !isLargeScreen ? (
    <FilterPillButtonSheet
      buttonLabel={maybePillLabel ?? 'Floor area'}
      sheetLabel="Floor area"
      selected={!!maybePillLabel}
      onReset={onReset}
      onFilterPillClose={onFilterPillClose}
      handleSearchOnClick={handleSearchOnClick}
      onFilterPillOpen={() => {
        trackPillClick();
      }}
      filter={
        <FloorAreaFilter
          searchQueryFloorAreaRange={selectedFloorAreaRange}
          onChange={onChange}
          showDivider={false}
          hideHeading
        />
      }
    />
  ) : (
    <FilterPillButton
      label={maybePillLabel ?? 'Floor area'}
      selected={!!maybePillLabel}
      onReset={onReset}
      onFilterPillClose={onFilterPillClose}
      handleSearchOnClick={handleSearchOnClick}
      onFilterPillOpen={() => {
        trackPillClick();
      }}
    >
      <FloorAreaFilter
        searchQueryFloorAreaRange={selectedFloorAreaRange}
        onChange={onChange}
        showDivider={false}
      />
    </FilterPillButton>
  );
};
